/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

import React from 'react'
import { useNavigate } from 'react-router-dom';

const ChangePassword = () => {
  const navigate = useNavigate();
  const changePassword = () => {
    navigate("/settings/change-password");
  };
  return (
    <div>
      <div
        className="col-12"
        onClick={changePassword}
        style={{ cursor: "pointer" }}
      >
        <div className="snippet-block h-100 d-flex align-items-center justify-content-between">
          <div className="cont d-flex align-items-center">
            <img
              className="img-fluid me-2"
              src="/assets/images/key-circle-ico.svg"
              alt="ico"
            />
            <p className="mid-gray mb-0">Change Password</p>
          </div>
          <button
            className="btn btn-primary btn-ico btn-empty change-btn pe-0"
            onClick={changePassword}
          >
            <i className="material-symbols-outlined me-0">
              chevron_right
            </i>
          </button>
        </div>
      </div>
    </div>
  )
}

export default ChangePassword
